__turbopack_context__.v({
  "checkbox_label": "PurposeGroup-module-scss-module__tvwvGW__checkbox_label",
  "label": "PurposeGroup-module-scss-module__tvwvGW__label",
  "label_row": "PurposeGroup-module-scss-module__tvwvGW__label_row",
  "options": "PurposeGroup-module-scss-module__tvwvGW__options",
  "required_dot": "PurposeGroup-module-scss-module__tvwvGW__required_dot",
  "root": "PurposeGroup-module-scss-module__tvwvGW__root",
});
